var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"answer-wrap"},[_c('TopicAnswer',{ref:"topicAnswer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }